export default {
  auth: {
    username: "Uporabniško ime",
    password: "Geslo",
    login: "Prijava",
    "forgot-password": "Pozabljeno geslo"
  }
}
